import {
  DayOfWeek,
  PoEmailFrequency,
} from "@redotech/redo-model/po-email-settings";
import * as z from "zod/v4";

export const updatePoEmailSettings = {
  name: "updatePoEmailSettings" as const,
  input: z.object({
    enabled: z.boolean(),
    recipients: z.array(z.string().email()),
    frequency: z.nativeEnum(PoEmailFrequency),
    dayOfWeek: z.nativeEnum(DayOfWeek),
  }),
  output: z.object({
    id: z.string(),
    accountId: z.string(),
    enabled: z.boolean(),
    recipients: z.array(z.string()),
    frequency: z.nativeEnum(PoEmailFrequency),
    dayOfWeek: z.nativeEnum(DayOfWeek),
    lastSentAt: z.coerce.date().nullable(),
    nextRunAt: z.coerce.date().nullable(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
  }),
};
